module.exports = __webpack_public_path__ + "img/social-studies-3-en.cdce6094.png";